import { Loadable } from 'utils/components';
import { MAP_PATH as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'Map' */ './components/MapPage')
  })
};
